//manage all the base api urls
const base = {    
    develop: {
        backend:'http://127.0.0.1:8000',   
        frontend:'http://127.0.0.1:8080' 
    },
    production1:{
        backend:'https://dashboard.tripleasuperdigital.com.au',
        frontend:'https://dashboard.tripleasuperdigital.com.au',
    }, 
    production2: {
        backend:'http://www.tripleasuperdigital.com.au',
        frontend:'http://www.tripleasuperdigital.com.au',

    },
}
const env = base.production1       
export default env;